import React from "react";
import { Badge } from "@KristianIV/common-ui";
import { FastTrackScout } from "./model/fastTrack";
import { reviewScoutUrl } from "./reviewLinks";
import styles from "./OrganisationPage.module.css";

/** The fast-track flag; opens the scout in the Review app, where the enrolment is managed. */
const FastTrackBadge = ({ fastTrack, deviceId, size }: { fastTrack: FastTrackScout; deviceId: string; size?: "big" }) => (
  <a
    href={reviewScoutUrl(deviceId)}
    target="_blank"
    rel="noopener noreferrer"
    className={styles.flagLink}
    title="Open in Review"
  >
    <Badge size={size} color={fastTrack.paused ? "amber" : "green"}>
      Fast track · {fastTrack.group}
      {fastTrack.paused ? " · Paused" : ""}
    </Badge>
  </a>
);

export default FastTrackBadge;
